// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"920aa636","453":"77ab3dec"}[chunkId] + ".chunk.js";
};